import { useState } from 'react'
import { TriggerView } from 'widgets/TriggerView'
import { TriggerViewStore } from 'widgets/TriggerView/store/triggerViewStore'
import { useTriggersPageContext } from 'pages/triggers/context'

export const CreateTrigger = () => {
  const { entities } = useTriggersPageContext()
  const [store] = useState(() => new TriggerViewStore(entities))
  return <TriggerView store={store} />
}
